import { Routine } from 'redux-saga-routines';
import {
  fetchRefRequestRoutine,
  confirmPrivacyPolicyRoutine,
  checkCodeRoutine,
  addPhoneNumberRoutine,
  setCurrentReferenceRoutine,
  setReferencesRoutine,
  deleteReferenceRoutine,
  editReferenceRoutine,
  setEditReferenceRoutine,
  saveReferencesRoutine,
  checkKeyRoutine,
  checkPhoneNumberRoutine
} from '../routines';
import { IRefReqCandidateForm } from '../../../common/models/referenceRequest/IRefReqCandidateForm';
import { map, filter } from 'ramda';
import { IReferenceCandidateForm } from '../../../common/models/reference/IReferenceCandidateForm';

export type CandidateFormState = IRefReqCandidateForm & {
  updatedReferencesIds: string[];
  currentReference: IReferenceCandidateForm;
  updateReference: IReferenceCandidateForm;
  defaultReferenceMail: string;
  errorCode: string;
  isChecking: boolean;
  invalidPhoneNumber?: string;
  isCheckingPhoneNumber: boolean;
  error: string | null;
};

const initialState = { } as CandidateFormState;

export const referenceRequest = (state: CandidateFormState = initialState, { payload, type }: Routine<any>) => {
  switch (type) {
    case checkCodeRoutine.TRIGGER:
      return {
        ...state,
        isChecking: true,
        errorCode: undefined
      };
    case checkCodeRoutine.FAILURE:
      return {
        errorCode: payload,
        isChecking: false
      };
    case checkCodeRoutine.SUCCESS:
    case fetchRefRequestRoutine.SUCCESS:
      return {
        ...payload,
        currentReference: { } as IReferenceCandidateForm,
        references: payload.references || [],
        updatedReferencesIds: [],
        isChecking: false
      };
    case confirmPrivacyPolicyRoutine.SUCCESS:
      return {
        ...state,
        privacyPolicyAgreed: true
      };
    case checkPhoneNumberRoutine.TRIGGER:
      return {
        ...state,
        isCheckingPhoneNumber: true
      };
    case checkPhoneNumberRoutine.SUCCESS:
      return {
        ...state,
        isCheckingPhoneNumber: false
      };
    case checkPhoneNumberRoutine.FAILURE:
      return {
        ...state,
        invalidPhoneNumber: payload,
        isCheckingPhoneNumber: false
      };
    case addPhoneNumberRoutine.SUCCESS:
      return {
        ...state,
        phoneNumber: payload.phoneNumber
      };
    case setCurrentReferenceRoutine.TRIGGER:
      return {
        ...state,
        currentReference: payload
      };
    case setReferencesRoutine.TRIGGER:
      return {
        ...state,
        references: payload,
        currentReference: { } as IReferenceCandidateForm
      };
    case deleteReferenceRoutine.TRIGGER:
      return {
        ...state,
        references: filter(r => r.id !== payload, state.references)
      };
    case setEditReferenceRoutine.TRIGGER:
      return {
        ...state,
        updateReference: payload
      };
    case editReferenceRoutine.TRIGGER:
      return {
        ...state,
        updatedReferencesIds: [...state.updatedReferencesIds, payload.id],
        references: map(ref => (ref.id === payload.id ? payload : ref), state.references),
        updateReference: { } as IReferenceCandidateForm
      };
    case saveReferencesRoutine.SUCCESS:
      return {
        ...state,
        updatedReferencesIds: []
      };
    case checkKeyRoutine.FAILURE:
      return {
        ...state,
        error: payload
      };
    default:
      return state;
  }
};
